import { useQuery } from "@tanstack/react-query";

import { fetchAllCoinPrices } from "../services/markets/coinPrice";
import type { Prices } from "services/domain/coinSymbols";

const refetchInterval = 5 * 60 * 1000;
const staleTime = 5 * 60 * 1000;

export function usePrices(): Prices {
  const { data } = useQuery(["AllCoinPrices"], () => fetchAllCoinPrices(), {
    refetchInterval,
    staleTime,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return data ?? {};
}
